if (!customElements.get('cart-upsell-add')) {
  class CartUpsellAdd extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      if (this.button.classList.contains('loading')) return;
      this.addToCart();
    }

    async addToCart() {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.button.classList.add('loading');
      const spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const cartDrawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        const sectionIds = cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
        formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(this.button);
        }
      }

      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        });
        const data = await response.json();

        if (data.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cart-upsell-add',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });
          }
          console.error('[CartUpsellAdd] Add failed:', data);
          return;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell-add',
            productVariantId: variantId,
            cartData: data,
          });
        }
      } catch (err) {
        console.error('[CartUpsellAdd] Add request failed:', err);
      } finally {
        this.button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }
    }
  }

  customElements.define('cart-upsell-add', CartUpsellAdd);
}
